import { Component, OnInit } from '@angular/core';
import { AngularFirestoreCollection } from '@angular/fire/firestore';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-referidos',
  templateUrl: './referidos.component.html',
  styleUrls: ['./referidos.component.scss']
})
export class ReferidosComponent implements OnInit {

  private itemsCol: AngularFirestoreCollection<any>;
  public  items:    Observable<any>;

  public displayedColumns = ["nombres", "telefono", "estado", "fechaNuevo", "tendero", "options" ];

  constructor() { }

  ngOnInit() {
  }

}
